export type LeadStatsRangeChoice =
  | { label: string; days: number }
  | { label: string; all: true }

export const DEFAULT_LEAD_STATS_RANGE: LeadStatsRangeChoice = { label: "30d", days: 30 }

export const LEAD_STATS_RANGE_OPTIONS: LeadStatsRangeChoice[] = [
  { label: "Today", days: 1 },
  { label: "7d", days: 7 },
  DEFAULT_LEAD_STATS_RANGE,
  { label: "90d", days: 90 },
  { label: "12m", days: 365 },
  // The API derives this from the site's earliest lead rather than applying
  // the custom-range ceiling, so it remains genuinely all-time.
  { label: "All time", all: true },
]

export function isAllTimeLeadStatsRange(
  choice: LeadStatsRangeChoice
): choice is { label: string; all: true } {
  return "all" in choice
}

export function isTodayLeadStatsRange(choice: LeadStatsRangeChoice): boolean {
  return !isAllTimeLeadStatsRange(choice) && choice.days === 1
}

export function leadStatsRangeParams(choice: LeadStatsRangeChoice):
  | { range: "all" | "today" }
  | { days: number } {
  if (isAllTimeLeadStatsRange(choice)) return { range: "all" }
  return choice.days === 1 ? { range: "today" } : { days: choice.days }
}

export function leadStatsPeriodLabel(days: number): string {
  if (days === 1) return "day"
  if (days === 365) return "12 months"
  return `${days} days`
}
